const shadows = {};

const radii = {
  card: '0.4rem'
};

export { shadows, radii };
